var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOptimizedIndexesIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Optimized Indexes Icon ")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Optimized-Indexes-Icon-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M13.1041405,34.4978784 C14.1848653,36.3894484 16.2509258,37.3352192 19.3023839,37.3352192 C22.3538421,37.3352192 24.4119562,36.4054784 25.476788,34.5459689 C26.5416197,32.6864593 27.0740276,29.5686216 27.0740276,25.1923621 C27.0740276,20.8161026 26.5257269,17.6341448 25.4291092,15.6463932 C24.3324914,13.6586416 22.2902701,12.6647808 19.3023839,12.6647808 C16.3144978,12.6647808 14.2643301,13.6586416 13.1518193,15.6463932 C12.0393085,17.6341448 11.4830615,20.8000726 11.4830615,25.1442716 C11.4830615,29.4884706 12.0234158,32.6063083 13.1041405,34.4978784 Z M29.6010038,37.960396 C27.6620564,40.6534788 24.2292174,42 19.3023839,42 C14.3755504,42 10.9268187,40.6454638 8.95608532,37.9363508 C6.98535192,35.2272378 6,30.971269 6,25.1683168 C6,19.3653647 6.99329831,15.0532909 8.97992472,12.2319661 C10.9665511,9.41064124 14.4073365,8 19.3023839,8 C24.1974314,8 27.6302704,9.40262624 29.6010038,12.2079208 C31.5717372,15.0132153 32.5570891,19.3333042 32.5570891,25.1683168 C32.5570891,31.0033295 31.5717372,35.2673133 29.6010038,37.960396 Z M38.7076537,41.4710042 L38.7076537,8.52899576 L44,8.52899576 L44,41.4710042 L38.7076537,41.4710042 Z",
    id: "OI",
    fill: "#0039CB",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOptimizedIndexesIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Optimized_Indexes_Icon.b6bd1591.svg";
export { ForwardRef as ReactComponent };